<template>
  <!-- <div> Confirm Reseller </div> -->
  <a-form
    :form="form"
    @submit.prevent="submit"
  >
    <a-form-item label="Select Level Model">
      <a-select
        v-decorator="['level_model', {
          rules: [{
            required: true,
            message: 'level model is required'
          }],
          initialValue: level_model_id && level_model_id
        }]"
        placeholder="Select Level Model"
        class="w-50"
      >
        <a-select-option v-for="item in levelModels" :key="item.id">
          <div class="d-flex justify-content-between" :value="item.level_id">
            <div> {{ item.level_name }}: </div>
            <!-- <div> - </div> -->
            <div> {{ item.default_discount }}% </div>
          </div>
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button
        type="primary"
        size="large"
        html-type="submit"
      >
        Submit
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import BaseURL from '@/services/axios'

export default {
  name: 'confirm.seller',
  data: function () {
    return {
      levelModels: null,
      form: this.$form.createForm(this),
    }
  },
  props: ['seller_hashid', 'store_status', 'level_model_id', 'flagModal'],
  methods: {
    async fetchLevelModels () {
      try {
        const { data: response } = await BaseURL({
          method: 'get',
          url: '/level_models/private',
        })
        this.levelModels = response.data
      } catch (error) {
        console.log(error)
      }
    },
    submit () {
      this.form.validateFieldsAndScroll(async (err, { level_model }) => {
        if (err) return
        try {
          await BaseURL({
            method: 'post',
            url: '/level_models/private',
            data: {
              seller_hashid: this.seller_hashid,
              levelmodel_id: level_model,
              store_status: 'active',
              store_enable: 1,
            },
          })
          this.$notification.success({
            message: this.flagModal === 'update' ? 'Success update level models' : 'Seller register confirmation success',
          })
          this.$emit('submitLevelModels')
          this.form.resetFields()
        } catch (error) {
          this.$notification.error({
            message: error?.response?.data?.message || error.message,
          })
        }
      })
    },
  },
  created () {
    this.fetchLevelModels()
  },
}
</script>
